module.exports = __webpack_public_path__ + "img/flex_temple.ca47e66.webp";